// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__mBwT_","Open":"SideDrawer_Open__2YCRM","Close":"SideDrawer_Close__1KiEK"};